import React from 'react';
import { Button, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Styled button with RTL support
const StyledButton = styled(Button)(({ theme, isRtl, variant }) => ({
  borderRadius: '6px',
  padding: '8px 16px',
  minHeight: '42px',
  minWidth: '120px',
  textTransform: 'none',
  fontWeight: 500,
  fontSize: '0.95rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  boxShadow: variant === 'contained' ? '0 2px 5px rgba(0,0,0,0.12)' : 'none',
  border: variant === 'outlined' ? '1px solid' : 'none',
  borderColor: variant === 'outlined' ? theme.palette.divider : 'transparent',
  '&:hover': {
    boxShadow: variant === 'contained' ? '0 4px 8px rgba(0,0,0,0.15)' : 'none',
    borderColor: variant === 'outlined' ? theme.palette.primary.main : 'transparent',
    backgroundColor: variant === 'outlined' ? 'rgba(25, 118, 210, 0.04)' : undefined,
  },
  ...(isRtl && {
    flexDirection: 'row-reverse',
  }),
}));

// Action button component with RTL support
const ActionButton = ({ 
  children, 
  startIcon, 
  endIcon, 
  variant = 'contained', 
  color = 'primary',
  onClick,
  disabled = false,
  fullWidth = false,
  type = 'button',
  component,
  to,
  sx = {},
  ...props
}) => {
  const { i18n } = useTranslation();
  const isRtl = i18n.language === 'dari' || i18n.language === 'ps';

  return (
    <StyledButton
      variant={variant}
      color={color}
      onClick={onClick}
      disabled={disabled}
      fullWidth={fullWidth}
      type={type}
      component={component}
      to={to}
      startIcon={!isRtl ? startIcon : null}
      endIcon={isRtl ? startIcon : endIcon}
      isRtl={isRtl}
      sx={{ ...sx }}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default ActionButton; 